<template>
  <form @submit.prevent="submitForm">
    <FormField
      id="MaterialClave"
      label="Clave Material"
      type="text"
      v-model="formData.MaterialClave"
      :required="true"
      :maxlength="50"
      :disabled="isEditing"
      helpText="Clave del material"
    />
    
    <FormField
      id="AlmacenClave"
      label="Clave Almacén"
      type="text"
      v-model="formData.AlmacenClave"
      :required="true"
      :maxlength="50"
      :disabled="isEditing"
      helpText="Clave del almacén"
    />
    
    <!-- Campo EmpresaId oculto - se captura automáticamente -->
    <input type="hidden" v-model="formData.EmpresaId" />
    
    <FormField
      id="EnStock"
      label="En Stock"
      type="number"
      v-model="formData.EnStock"
      :required="true"
      step="0.01"
      min="0"
      helpText="Cantidad en stock"
    />
    
    <FormField
      id="Comprometido"
      label="Comprometido"
      type="number"
      v-model="formData.Comprometido"
      :required="true"
      step="0.01"
      min="0"
      helpText="Cantidad comprometida"
    />
    
    <FormField
      id="Pedido"
      label="Pedido"
      type="number"
      v-model="formData.Pedido"
      :required="true"
      step="0.01"
      min="0"
      helpText="Cantidad pedida"
    />
    
    <div class="d-flex gap-2 mt-4">
      <button type="button" class="btn btn-primary" :disabled="loading" @click="submitForm">
        <span v-if="loading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
        <i v-else class="bi bi-save me-1"></i>
        {{ isEditing ? 'Actualizar' : 'Guardar' }}
      </button>
      <button type="button" class="btn btn-secondary" @click="$emit('cancel')">
        <i class="bi bi-x-circle me-1"></i> Cancelar
      </button>
    </div>
  </form>
</template>

<script>
import FormField from '@/shared/components/FormField.vue';
import empresaMixin from '@/shared/mixins/empresaMixin';

export default {
  name: 'CatMaterialAlmacenForm',
  components: {
    FormField
  },
  mixins: [empresaMixin],
  props: {
    materialAlmacen: {
      type: Object,
      default: () => ({
        MaterialClave: '',
        AlmacenClave: '',
        EmpresaId: null,
        EnStock: 0,
        Comprometido: 0,
        Pedido: 0
      })
    },
    isEditing: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: { ...this.materialAlmacen }
    };
  },
  watch: {
    materialAlmacen: {
      handler(newValue) {
        this.formData = { ...newValue };
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    submitForm() {
      // Asegurar que la empresa esté capturada antes de enviar
      this.ensureEmpresaCaptured();
      
      // Preparar datos para envío
      const dataToSubmit = { ...this.formData };
      
      this.$emit('submit', dataToSubmit);
    }
  }
};
</script>

<style scoped>
/* Estilos específicos del formulario si son necesarios */
</style>
